<section class="banner-section">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-12">
                <div class="banner-title">
                    <div class="title"><h1>免费在线拼写检查工具</h1></div>
                    <p>使用Trinka的免费拼写检查工具实时纠正拼写错误。<br/> 觉得分辨单词的正确拼写很困难？Trinka AI能够根据您的学科领域识别和建议正确的单词拼写，进一步提高您的写作。Trinka更重要的是能够根据句子的上下文建议拼写更正，始终为您提供最佳建议！</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <app-english-grammar-checker></app-english-grammar-checker>
            </div>
        </div>
    </div>
    <span class="shape-1"></span>
    <span class="shape-2"></span>
    <span class="shape-3"></span>
</section>

<div class="gcBrowserSection">
    <div class="container">
        <div class="row">
            <div class="gcBrowserContainer">
                <h2>随时随地进行高级上下文拼写检查！ </h2>
                <a  id="GCChromeButton" href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"><img src="assets/images/NewChromeIcon.svg" alt=""> 安装谷歌插件</a>
                <a  id="GCFirFoxButton" href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank"><img src="assets/images/NewFirefoxIcon.svg" alt=""> 安装火狐插件</a>
                <a  id="GCEdgeButton" href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"><img src="assets/images/EdgeWhite_BGAndOutline.svg" alt=""> 安装Edge插件</a>
            </div>
        </div>
    </div>
</div>

<div class="signupmobile" style="display: none !important;">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="trinkaPluginGCSection">
                    <h2>您的免费Trinka账号</h2>
                    <p>每个月为您免费检查多达5000个单词的写作，让您的语言和写作风格得到全面提升。</p>
                    <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">立即注册！</a>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="trinka_demo_wrap gcBannerSection">
    <div class="see_trinka_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="top_heading howItWorkHeading lineWhiteColor">
                        <h1>免费在线拼写检查工具</h1>
                        <div class="HeadingSubLine"></div>
                        <p>使用Trinka的免费拼写检查工具实时纠正拼写错误。<br/> 觉得分辨单词的正确拼写很困难？Trinka AI能够根据您的学科领域识别和建议正确的单词拼写，进一步提高您的写作。Trinka更重要的是能够根据句子的上下文建议拼写更正，始终为您提供最佳建议！</p>
                    </div>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-lg-7 col-md-9 col-sm-12 col-12">
                    <div class="gcResultSection">
                        <div class="trinkaPluginGCSection">
                            <p>免费语法检查工具正在进行升级，目前无法使用。然而，这不妨碍您使用Trinka帮助您的写作。</p>
                            <p>注册使用免费在线编辑器，它每月可实现5000字的免费检查，并有更强大的功能。</p>
                            <div class="text-center"><a href="https://cloud.trinka.ai/signup?ref=CN-Spell" target="_blank">立即注册！</a></div>
                            <h3 class="text-center">特殊功能:</h3>
                            <div class="row">
                                <div class="col-md-10 offset-md-1">
                                    <ul class="row">
                                        <li class="col-lg-6 col-sm-6 col-12">检查语法和拼写错误</li>
                                        <li class="col-lg-6 col-sm-6 col-12">词汇选择建议</li>
                                        <li class="col-lg-6 col-sm-6 col-12">语言强化</li>
                                        <li class="col-lg-6 col-sm-6 col-12">写作建议</li>
                                        <li class="col-lg-6 col-sm-6 col-12">风格指南</li>
                                        <li class="col-lg-6 col-sm-6 col-12">个性化的字典</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="the_best_grammer_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="top_best_grammer_heading">
                    <h2>最佳免费在线拼写检查工具</h2>
                    <div class="HeadingSubLine"></div>
                    <p>Trinka的拼写检查工具可以识别您写作中最复杂的拼写错误并提供建议。</p>
                    <p>Trinka能帮助您以高精度修复最常见和最严重的语法和拼写错误，从而提高您的写作技巧和整体文档质量。</p>
                    <div class="most_suited_point">
                        <ul>
                            <li>高级上下文拼写检查</li>
                            <li>高级语法检查</li>
                            <li>免费享受</li>
                            <li>高质量的数据安全</li>
                        </ul>
                    </div>
                    <p>Trinka的在线拼写检查工具可检测拼写错误，并且提供建议和解释让您更容易理解。</p>
                    <p>注册以免费解锁更多功能！</p>
                    <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank" class="cta-btn">开始使用</a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="grammarCheckSection">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-md-4">
                <div class="grammarCheckHeadingSection">
                    <h2>谁可以使用Trinka的拼写检查工具？</h2>
                </div>
            </div>
            <div class="col-md-8">
                <div class="grammarCheckTextContent">
                    <p>Trinka适合任何希望提高英语写作技能的用户，它的免费拼写检查工具受到学者、文案、营销人员、内容作者、产品团队、博主、自出版作者等作者的信任。</p>
                </div>
            </div>
        </div> 
    </div>
</div>

<div class="the_best_grammer_sections">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="top_best_grammer_heading">
                    <h2>Trinka拼写检查工具的主要功能</h2>
                    <div class="HeadingSubLine"></div>
                    <!-- <p>Enhance and check your writing instantly with the best English grammar checker. Trinka's advanced
                        checking feature highlights mistakes and provides contextual suggestions that make your writing
                        rise and shine.</p> -->
                </div>
            </div>
        </div>
        <div class="row match-box">
            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>高级拼写检查</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinka的免费拼写检查工具能够根据写作上下文，为您的主题选择正确的单词。为您避免尴尬的拼写错误！</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Technical word choice</h4> -->
                            <p>The <span class="wrong_text">Bonferoni</span> <span
                                class="right_text"> Bonferroni</span> test was used to check for
                            statistical significance.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>适用于所有主题</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>您可以根据主题领域和内容类型自定义Trinka，为您提供最相关的建议。</p>
                        </div>
                        <div class="mini_card_grammer">
                            <!-- <h4>Sensitive language</h4> -->
                            <p>The physical properties of <span class="wrong_text">kytoplasm</span> <span
                                class="right_text"> cytoplasm</span> differ considerably from dilute aqueous solutions.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>个人词典</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>Trinka会记住您添加到词典中的所有单词并自动同步到所有平台，从而随时随地为您提供个性化的写作体验。</p>
                        </div>
                        <div class="mini_card_grammer min_auto">
                            <!-- <h4>Syntax</h4> -->
                            <div class="toolbox_img_content publication_checks_section pd_after">
                                <div class="personal_dictionary_section">
                                    <div class="personal_dic_left_text">
                                        <h2>Spelling
                                            <span>
                                                <i class="fa fa-plus"></i>Add to dictionary</span>
                                        </h2>
                                        <div class="personal_dic_text_section">
                                            <p class="personal_wrong_text">nanotubol</p>
                                            <img src="assets/images/spacingArrow.png" />
                                            <p class="personal_right_text">nanotubes</p>
                                        </div>
                                        <p>Please check the spelling</p>
                                    </div>
                                    <div class="consistency_left_side">
                                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                                        <ul>
                                            <li>
                                                <img src="assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                            </li>
                                            <li>
                                                <img src="assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-6 dflex">
                <div class="best_grammer_cards c-card">
                    <h3>全部接受并忽略</h3>
                    <div class="content_body_best_grammer">
                        <div class="best_content_text">
                            <p>需要更正整篇论文的拼写？不想反复看到单词建议？Trinka让一切变得简单！只需单击一下即可接受或忽略所有此类建议。</p>
                        </div>
                        <div class="mini_card_grammer min_auto">
                            <!-- <h4>Advance Spelling</h4> -->
                            <div class="toolbox_img_content publication_checks_section pd_after">
                                <div class="personal_dictionary_section">
                                    <div class="personal_dic_left_text">
                                        <h2>Spelling
                                            <b>
                                                <i class="fa fa-plus"></i>Add to dictionary</b>
                                        </h2>
                                        <div class="personal_dic_text_section">
                                            <p class="personal_wrong_text">nanotubol</p>
                                            <img src="assets/images/spacingArrow.png" />
                                            <p class="personal_right_text">nanotubes</p>
                                        </div>
                                        <div class="acceptAll_buttons_sections">
                                            <p>Accept for all similar alerts</p>
                                            <i>
                                                <img src="assets/images/info.svg" alt="">
                                            </i>
                                        </div>
                                        <p>Please check the spelling</p>
                                    </div>
                                    <div class="consistency_left_side">
                                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                                        <ul>
                                            <li>
                                                <img src="assets/images/Consistency_delete_icon.svg" title="Delete" style="width: 22px;">
                                            </li>
                                            <li class="acceptAll_rejectAll">
                                                <img src="assets/images/AcceptAll_consistencyCheks.svg" title="Ignore for all similar aterls" style="width: 22px;">
                                            </li>
                                            <li>
                                                <img src="assets/images/consistency_dislike_icon.svg" title="Incorrect suggestions" style="width: 20px;">
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
        </div>
    </div>
</div>

<div class="use_trinka_other_app">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="use_trinka_content">
                    <div class="use_trinka_heading">
                        <div class="howItWorkHeading lineWhiteColor">
                            <h2>在其他应用程序<br />中使用Trinka</h2>
                            <div class="HeadingSubLine"></div>
                        </div>
                    </div>
                    <div class="others_app_name">
                        <ul>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/trinkacloud']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/Other_apps_TrinkaCloud.svg" alt="">
                                        <h3>Cloud</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/wordplugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/wordAdd_in.svg" alt="">
                                        <h3>MS Word</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/NewChromeIcon.svg" alt="">
                                        <h3>Chrome</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/NewFirefoxIcon.svg" alt="">
                                        <h3>Firefox</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/EdgeWhite_BGAndOutline.svg" alt="">
                                        <h3>Edge</h3>
                                    </div>
                                </a>
                            </li>
                            <li>
                                <a>
                                    <div class="app_name_content" [routerLink]="['/browser-plugin']">
                                        <span class="safariComingSoonTag">Coming Soon</span>
                                        <div class="app_name_content_overlay"></div>
                                        <img src="assets/images/safari_logo.png" alt="">
                                        <h3>Safari</h3>
                                    </div>
                                </a>
                            </li>

                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="moreEffectiveSection">
    <div class="container">
        <div class="row flex-row-reverse align-items-center">
            <div class="col-md-6">
                <div class="moreEffectiveTextContent">
                    <h2>Trinka的免费拼写检查工具是如何工作的？</h2>
                    <p>Trinka的拼写检查工具不仅可以检测和纠正拼写错误，还可以检测语法错误。Trinka检测的拼写错误包括动词的分词形式、相近的单词拼写以及术语混淆等。</p>
                    <p>使用Trinka纠正所有类型的拼写错误，让您的写作传达清晰而自信的信息。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="moreEffectiveImages">
                    <img src="assets/images/WritingMoreEffective.png" alt="">
                </div>
            </div>
            
        </div>
        <div class="row colunmChangesSection align-items-center">
            <div class="col-md-6">
                <div class="moreEffectiveTextContent">
                    <h2>让您的写作避免拼写错误</h2>
                    <p>Trinka的人工智能拼写检查工具采用最新的机器学习（ML）和自然语言（NPL）技术开发而成，可识别最常见和最复杂的单词拼写错误。</p>
                    <p>想对您的研究论文、学术论文、电子邮件或论文进行拼写检查吗？Trinka将为您保驾护航。除了拼写检查，我们还将帮助您轻松修复语法错误。</p>
                </div>
            </div>
            <div class="col-md-6">
                <div class="moreEffectiveImages">
                    <img src="assets/images/LearnGrammarwithTrinka.png" alt="">
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="testimonail_demo_page">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="testimonail_heading">
                    <h2>Testimonials</h2>
                    <p>Check what users are saying about Trinka</p>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="assets/images/quote_icons.png" alt="">
                    </div>
                    <p>The grammar checking tool exceeds Grammarly! I re-checked some documents that I had checked
                        earlier with Grammarly. I was pleasantly surprised to see such a product from India!</p>
                    <div class="testimonals_footer">
                        <p>Radiologist, India</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-6">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="assets/images/quote_icons.png" alt="">
                    </div>
                    <p>First, I love Trinka. Congratulations on developing something that extensively aids editing,
                        especially critical grammar conventions and word count reductions.</p>
                    <div class="testimonals_footer">
                        <p>Academic Editor, USA</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-4 col-md-12">
                <div class="testimonals_cards">
                    <div class="icons_secion">
                        <img src="assets/images/quote_icons.png" alt="">
                    </div>
                    <p>I have tested Trinka and am impressed with its fine capabilities. It did better than the grammar
                        checker I use. Well done! I have told my colleagues in my research lab to use Trinka. Hope it is
                        widely used in academia.</p>
                    <div class="testimonals_footer">
                        <p>PhD Scholar, UK</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->
<section class="section-md gc-testimonials-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center testi">
                <div class="GCTestmonials">
                    <h2>使用感言</h2>
                    <div class="HeadingSubLine"></div>          
                </div>
            </div>
        </div>
    </div>
    <div class="testimonial text-center">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="testimonial-wrap">
                        <!-- <div class="testimonal-icon">
                            <img src="assets/images/testimonial.png" alt="grammar-checker-testimonial">
                        </div> -->
                        <div class="testimonial-slider">
                            <div id="testi" class="carousel slide" data-ride="carousel">
                                <ol class="carousel-indicators">
                                    <li data-target="#testi" data-slide-to="0" class="active"></li>
                                    <li data-target="#testi" data-slide-to="1"></li>
                                    <li data-target="#testi" data-slide-to="2"></li>
                                    <li data-target="#testi" data-slide-to="3"></li>
                                    <li data-target="#testi" data-slide-to="4"></li>
                                    <li data-target="#testi" data-slide-to="5"></li>
                                    <li data-target="#testi" data-slide-to="6"></li>
                                    <li data-target="#testi" data-slide-to="7"></li>
                                    <li data-target="#testi" data-slide-to="8"></li>
                                    <li data-target="#testi" data-slide-to="9"></li>
                                    <li data-target="#testi" data-slide-to="10"></li>
                                    <li data-target="#testi" data-slide-to="11"></li>
                                    <li data-target="#testi" data-slide-to="12"></li>
                                </ol>
                                <div class="carousel-inner">
                                    <div class="carousel-item active">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/James-Smith.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我一下就爱上Trinka了。祝贺你们开发出这个可以大幅协助编辑的程序，尤其是符合重要的语法惯例和具备精简字数功能的工具。
                                                    </p>
                                                    <p class="authorNameText">James Smith</p>
                                                    <span class="authorDesignationText">学术编辑, 美国</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Rosa-Diaz-Sandoval.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">对于说其他语言的人来说，用正确的英语语法和风格编写文章不是一件容易的事。如果没有辅助功能，尤其是学术写作，很难在文件中发现小错误。我尝试将TrinkaAI作为自动更正工具，并对建议的更正和反馈感到非常满意。通过反馈，能了解为什么必须考虑建议的更改。</p>
                                                    <p class="authorNameText">Rosa Diaz Sandoval</p>
                                                    <span class="authorDesignationText">物理和数学博士, 墨西哥</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Dr_Farooq_Rathore.jpg" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我使用Trinka两个多月了。我主要用它来改进我为国内和国际生物医学期刊撰写的科学手稿的语言、语法和句法。界面很用户友好，并且软件高效且好用。根据需要编辑手稿的不同选项有助于决定我需要关注的地方。自动编辑的帮助很大，带有修订历史的补充页面很有用。Trinka一直在更新，我写这篇文章时就注意到添加了一个新功能“一致性”。最好的部分是所有这些都是完全免费的。我强烈鼓励作者和研究人员，特别是那些英语不好的人尝试一下，亲眼目睹惊人的结果。</p>
                                                    <p class="authorNameText">Farooq Rathore博士</p>
                                                    <span class="authorDesignationText">助理教授兼系主任, 巴基斯坦</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Georgieva-Milena.jpg" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka.ai是我最喜欢的语法和拼写编辑。该应用程序使用效果好，快速而明确！完全满意！</p>
                                                    <p class="authorNameText">Milena Georgieva</p>
                                                    <span class="authorDesignationText">研究员</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Dinesh-Gupta.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">这是一个超越Grammarly的语法检查工具！我用Trinka重新检查了用Grammarly检查过一些文件。看到来自印度的如此优越产品，我感到非常惊喜！</p>
                                                    <p class="authorNameText">Dinesh Gupta</p>
                                                    <span class="authorDesignationText">放射科医师, 印度</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Edith-Davies.jpg" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我已经测试过Trinka，并对其出色的功能印象深刻。它比我使用的语法检查器做得更好。做得好！我已经告诉我研究实验室的同事使用Trinka。希望在学术界得到广泛应用。</p>
                                                    <p class="authorNameText">Edith Davies</p>
                                                    <span class="authorDesignationText">博士生, 英国</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Noor-Al-rishi.png" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka AI建议的更正和反馈令我惊喜。使用简单，非常有益。</p>
                                                    <p class="authorNameText">Noor Al-rishi</p>
                                                    <span class="authorDesignationText">化学学者, 沙特阿拉伯</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Nwaji-Jude.jpg" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">使用Trinka是美妙的体验，如果不使用它评估稿件，我几乎无法提交任何手稿。总之，Trinka成了我的是救命稻草。</p>
                                                    <p class="authorNameText">Nwaji Jude</p>
                                                    <span class="authorDesignationText">研究员</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Stumpf-Curtis.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我喜欢使用Trinka作为我编辑文稿的最终检查。它确实有助于找到在编辑过程中漏掉的剩余错误。我真的很喜欢这个平台。大拇指向下这个按钮非常有用。
                                                    </p>
                                                    <p class="authorNameText">Stumpf Curtis</p>
                                                    <span class="authorDesignationText">研究员</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Dyke-Gareth.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我认为Trinka.ai是一个非常有趣且很有发展潜力的主意，尤其是对于编辑/出版社/期刊。我使用这个平台检查我的编辑工作，非常有用。</p>
                                                    <p class="authorNameText">Gareth Dyke</p>
                                                    <span class="authorDesignationText">研究员</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Bhargava-Sharma.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">我对整体表现感到满意。我使用Grammarly已经有很长一段时间了，但是在学术或技术写作方面，Trinka绝对是更好的选择。学术文件设置和自动文件编辑是我最喜欢的功能。</p>
                                                    <p class="authorNameText">Bhargava Sharma</p>
                                                    <span class="authorDesignationText">流行病学家, 印度</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Ralph-Bailey.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">Trinka已成为我语法校正的首选工具。人工智能驱动的更正和语言增强使写作变得更加容易。现在，我可以更专注于研究，而不是纠正文稿中的错误。</p>
                                                    <p class="authorNameText">Ralph Bailey</p>
                                                    <span class="authorDesignationText">神经科医生, 美国</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
    
                                    <div class="carousel-item">
                                        <div class="row">
                                            <div class="col-lg-3">
                                                <div class="clientPhotos shadow">
                                                    <img src="assets/images/clientPhotos/Thomas-Andres.jfif" alt="">
                                                </div>
                                            </div>
                                            <div class="col-lg-9">
                                                <div class="clientMessageSection">
                                                    <i class="fa fa-quote-left" aria-hidden="true"></i>
                                                    <p class="start-text">基于AMA风格指南的语法纠正和建议真的令人印象深刻！Trinka确实是医学写作最好的语法校正工具。
                                                    </p>
                                                    <p class="authorNameText">Thomas Andres</p>
                                                    <span class="authorDesignationText">心脏学专家, 巴西</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <a class="carousel-control-prev" href="#testi" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                            <a class="carousel-control-next" href="#testi" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>


    
<div class="ready_to_levelUp">
    <div class="container">
        <div class="row">
            <div class="col-sm-12">
                <div class="level_up_heading">
                    <h3>高级语法和拼写检查</h3>
                    <a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank" id="grammerSignUpButton">
                        <!-- <i class="fa fa-sign-in"></i> -->
                        <span>免费注册！</span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="grammarCheckQuestions">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="GCQuestions">
                    <h2>Trinka的拼写检查工具常见问题解答</h2>
                    <div class="HeadingSubLine"></div>          
                </div>
                <div class="row">
                    <div class="offset-md-1 col-md-10">
                        <div class="answersSections">
                            <div class="accordion" id="QeustionGrammarChecks">
                                <div class="card">
                                    <div class="card-header" id="QuestionGCOne">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCOneContent" aria-expanded="true"
                                            aria-controls="QuestionGCOneContent">
                                            什么是拼写检查工具？</a>
                                    </div>
        
                                    <div id="QuestionGCOneContent" class="collapse show"
                                        aria-labelledby="QuestionGCOne" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>拼写检查工具可以帮助识别文档​​中的拼写错误或印刷错误，并根据上下文将其替换为正确的单词。</p>
                                        </div>
                                    </div>
                                </div>        
                                
                                <div class="card">
                                    <div class="card-header" id="QuestionGCTwo">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCTwoContent" aria-expanded="true"
                                            aria-controls="QuestionGCTwoContent">Trinka如何检查拼写错误？</a>
                                    </div>
        
                                    <div id="QuestionGCTwoContent" class="collapse"
                                        aria-labelledby="QuestionGCTwo" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>只需将您的内容粘贴到编辑器中，然后单击“检查我的写作”，Trinka将突出显示所有拼写错误并提供最佳的上下文拼写建议。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="card">
                                    <div class="card-header" id="QuestionGCThree">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCThreeContent" aria-expanded="true"
                                            aria-controls="QuestionGCThreeContent"> Trinka的拼写检查工具是免费使用的吗？</a>
                                    </div>
        
                                    <div id="QuestionGCThreeContent" class="collapse"
                                        aria-labelledby="QuestionGCThree" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            <p>当然可以，您可以免费使用此页面上的编辑器来检查您的内容。如果您想检查更长的文档，请在此处<a href="https://cloud.trinka.ai/signup?_rg=CN" target="_blank">注册</a>并免费获得更多功能。</p>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="card">
                                    <div class="card-header" id="QuestionGCFour">
                                        <a href="#" class="btn btn-header-link" data-toggle="collapse"
                                            data-target="#QuestionGCFourContent" aria-expanded="true"
                                            aria-controls="QuestionGCFourContent">我可以检查不同网站上的拼写吗？</a>
                                    </div>
        
                                    <div id="QuestionGCFourContent" class="collapse"
                                        aria-labelledby="QuestionGCFour" data-parent="#QeustionGrammarChecks">
                                        <div class="card-body">
                                            可以。您只需在谷歌Chrome、火狐Firefox或微软Edge浏览器上安装我们的<a  [routerLink]="['/browser-plugin']">插件</a>，就可以在任何网站使用Trinka的拼写检查工具。
                                        </div>
                                    </div>
                                </div>

                                
        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
